import { render, staticRenderFns } from "./CadastroFlorestal.vue?vue&type=template&id=4c22d4bf&scoped=true"
import script from "./CadastroFlorestal.vue?vue&type=script&lang=js"
export * from "./CadastroFlorestal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c22d4bf",
  null
  
)

export default component.exports